<script>
  import {
    REQUEST_REPORT_PASSAGES,
    REQUEST_REPORT_BALANCE_HISTORY,
  } from '@/requests/parent'
  import ReportsView from "@/views/common/ReportsView";
  import {REPORT_TYPES} from "@/views/common/ReportsView";
  import API from "@/config/api";
  import {mapState} from "vuex";

  export default {
    extends: ReportsView,
    name: 'ParentReportsView',
    data() {
      return {
        reportTypes: [
          {
            request: REQUEST_REPORT_PASSAGES,
            name: 'Проходы',
            type: [REPORT_TYPES.withDates],
          },
          {
            request: REQUEST_REPORT_BALANCE_HISTORY,
            name: 'Операции со счетом',
            type: [REPORT_TYPES.withDates],
          }
        ],
        suggestionsUnit: null,
        suggestionsParentUnit: null,
        downloadReport: API.parent.reports.download
      }
    },
    computed: {
      ...mapState({
        childId: state => state.child.childId
      }),
    },
  }
</script>